import { useMutation } from '@tanstack/react-query'
import { adminApis } from 'api'

export default function useLogout() {
  const { mutateAsync, isPending: isLogout } = useMutation({
    mutationFn: (userName: string) => adminApis.logout(userName),
  })

  const onLogout = async (usr: string) => {
    return await mutateAsync(usr)
  }
  return { onLogout, isLogout }
}
